import React from 'react';
import './LoadMoreButton.css';

export interface LoadMoreButtonProps {
  /** Função chamada ao clicar no botão */
  onClick: () => void;
  /** Indica se está carregando mais itens */
  isLoading?: boolean;
  /** Indica se tem mais itens para carregar */
  hasMore?: boolean;
  /** Texto customizado do botão (opcional) */
  label?: string;
  /** Classe CSS adicional */
  className?: string;
}

/**
 * Componente de botão "Ver Mais" para paginação manual
 *
 * @example
 * ```tsx
 * <LoadMoreButton
 *   onClick={loadMore}
 *   isLoading={isLoading}
 *   hasMore={hasMore}
 * />
 * ```
 */
export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  isLoading = false,
  hasMore = true,
  label = 'Ver Mais',
  className = ''
}) => {
  // Não exibe o botão se não há mais itens
  if (!hasMore && !isLoading) {
    return null;
  }

  return (
    <div className={`load-more-button-container ${className}`}>
      <button
        className="load-more-button"
        onClick={onClick}
        disabled={isLoading || !hasMore}
        type="button"
      >
        {isLoading ? (
          <>
            <i className="fas fa-spinner fa-spin"></i>
            <span>Carregando...</span>
          </>
        ) : (
          <>
            <i className="fas fa-chevron-down"></i>
            <span>{label}</span>
          </>
        )}
      </button>
    </div>
  );
};

export default LoadMoreButton;
